import * as React from 'react';

function SvgPaperPlaneOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M21.81 2.191L10.605 13.396m-8.361-4.09l19.235-7.28a.385.385 0 01.497.496l-7.28 19.235a.386.386 0 01-.722-.016l-3.24-7.987a.77.77 0 00-.487-.486L2.26 10.029a.384.384 0 01-.016-.724v0z" })));
}

export default SvgPaperPlaneOutline;
